<template>
    <!-- arrow container -->
    <div class="arrow-container">

      <!-- left -->
      <div class="bracket-left">
        <svg width="36px" height="24px" viewBox="0 0 36 24">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g class="fill-group">
              <polygon points="0 24 6 24 6 22 2.08571429 22 2.08571429 2 6 2 6 0 0 0"></polygon>
            </g>
          </g>
        </svg>
      </div>

      <!-- right -->
      <div class="bracket-right">
        <svg width="36px" height="24px" viewBox="0 0 36 24">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g class="fill-group">
              <polygon points="30 24 36 24 36 0 30 0 30 2 34 2 34 22 30 22"></polygon>
            </g>
          </g>
        </svg>
      </div>

      <!-- chevron -->
      <div class="arrow">
        <!-- next -->
        <svg v-if="type === 'next'" width="36px" height="24px" viewBox="0 0 36 24">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g class="fill-group">
              <polygon points="13 18 23 13 23 11 13 6 13 8 21 12.0218182 13 16"></polygon>
            </g>
          </g>
        </svg>

        <!-- share -->
        <svg v-else-if="type === 'share'" width="36px" height="24px" viewBox="0 0 36 24">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g class="fill-group share-icon">
                <path d="M16.9990234,18 L19,18 L19,13 L24,13 L24,11 L19,11 L19,6 L16.9990234,6 L16.9990234,11 L12,11 L12,13 L16.9990234,13 L16.9990234,18 Z"></path>
              </g>
            </g>
        </svg>

        <!-- prev -->
        <svg v-else width="36px" height="24px" viewBox="0 0 36 24">
          <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g class="fill-group">
                <path d="M23,18 L13,13 L13,11 L23,6 L23,8 L15,12.0218182 L23,16 L23,18 Z"></path>
              </g>
          </g>
        </svg>
      </div>

    </div>
</template>

<script>
  export default {
    props: ['type']
  }
</script>

<style scoped lang="scss">
  @import '../../styles/variables';

  .arrow-container {
    position: relative;
    cursor: pointer;
    width: 36px;
    height: 24px;
    &:hover {
      .bracket-left {
        transform: translateX(-3px);
      }
      .bracket-right {
        transform: translateX(3px);
      }
    }
  }

  .bracket-left, .bracket-right, .arrow {
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    transition: all $transition-1;
  }

  .fill-group, .share-icon {
    fill: $black;
    transition: all $transition-1;
  }

</style>



// WEBPACK FOOTER //
// arrow.vue?51c89618